import { useEffect, useState } from "react";

export function useNouveauxMurs(userId?: number) {
  const [aDesNouveauxMurs, setAucunNouveauMur] = useState(false);

  useEffect(() => {
    if (!userId) return;

    const fetchNouveauxMurs = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_USER_URL}/MurDeBrique/nouveaux?userId=${userId}`);
        if (!res.ok) return;

        const murs = await res.json();
        setAucunNouveauMur(murs.length > 0);
      } catch (err) {
        console.error("Erreur check nouveaux murs :", err);
      }
    };

    fetchNouveauxMurs();
  }, [userId]);

  return aDesNouveauxMurs;
}